/**
 * 平台报告查询相关路由
 */
export default [
  {
    path: '/plat/report',
    component: () => import('../../src/pages/plat-report/index')
  },
  /**
   * 我的检查/检验 列表
   */
  {
    path: '/plat/report/list',
    component: () => import('../../src/pages/plat-report/list')
  },
  /**
   * 我的检查/检验 详情
   * query
   * id 订单id
   * type 类型 CHECK/INSPECT
   */
  {
    path: '/plat/report/detail',
    component: () => import('../../src/pages/plat-report/detail')
  },
]



// WEBPACK FOOTER //
// ./src/router/plat-report.js